import { render, staticRenderFns } from "./RoadmapBaseEventsList.vue?vue&type=template&id=7b212004&"
import script from "./RoadmapBaseEventsList.vue?vue&type=script&lang=js&"
export * from "./RoadmapBaseEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports